import {
  getSubscriptionPackages,
  getSubscriptionPriceTiers,
  setSubscriptionPackages,
  getSubscriptionsForCoachGame,
} from "@/api/coachSubscription"

const state = {
  priceTiers: [],
  newSubscriptionPackages: [],
  subscriptionPackages: [],
  studentsFilter: "",
  showUnsubscribedUser: false,
  studentsSorting: {
    type: "STUDENT",
    order: 1,
  },
  subscriptionForGame: [],
  selectedSubscriptionGame: null,
}

const getters = {
  priceTiers: state => state.priceTiers,
  newSubscriptionPackages: state => state.newSubscriptionPackages,
  subscriptionPackages: state => state.subscriptionPackages,
  studentsFilter: state => state.studentsFilter,
  showUnsubscribedUser: state => state.showUnsubscribedUser,
  studentsSorting: state => state.studentsSorting,
  subscriptionForGame: state => state.subscriptionForGame,
  selectedSubscriptionGame: state => state.selectedSubscriptionGame,
}

const mutations = {
  setPriceTiers: (state, tiers) => (state.priceTiers = tiers),
  setNewSubscriptionPackages: (state, packages) =>
    (state.newSubscriptionPackages = packages),
  setSubscriptionPackages: (state, packages) =>
    (state.subscriptionPackages = packages),
  setStudentFilter: (state, filter) => (state.studentsFilter = filter),
  setShowUnsubscribedUser: (state, showUnsubscribedUser) =>
    (state.showUnsubscribedUser = showUnsubscribedUser),
  setStudentsSorting: (state, studentsSorting) =>
    (state.studentsSorting = { ...studentsSorting }),
  setSubscriptionForGame: (state, subscriptions) =>
    (state.subscriptionForGame = subscriptions),
  setSelectedSubscriptionGame: (state, selectedSubscriptionGame) =>
    (state.selectedSubscriptionGame = selectedSubscriptionGame),
}

const actions = {
  async getPriceTiers ({ commit, rootGetters }) {
    const instaProAccessToken =
      rootGetters["User/Coaching/getInstaProAccessToken"]
    const data = await getSubscriptionPriceTiers(instaProAccessToken)
    if (data.success) {
      commit("setPriceTiers", data.result)
    }
  },
  addNewSubscriptionPackage: ({ commit, state }, pack) => {
    const newSubscriptionPackages = [
      ...state.newSubscriptionPackages,
      pack,
    ].sort((a, b) => {
      const aPrice = a?.coach_subs_price?.price_amount ?? 0
      const bPrice = b?.coach_subs_price?.price_amount ?? 0

      if (aPrice < bPrice) {
        return -1
      } else if (aPrice > bPrice) {
        return 1
      } else {
        return 0
      }
    })
    commit("setNewSubscriptionPackages", newSubscriptionPackages)
  },
  async getSubscriptionPackages ({ commit, rootGetters, state }, coachGameId) {
    const instaProAccessToken =
      rootGetters["User/Coaching/getInstaProAccessToken"]
    let data
    if (coachGameId) {
      data = await getSubscriptionPackages(coachGameId, instaProAccessToken)
    } else {
      data = await getSubscriptionPackages(
        state.selectedSubscriptionGame.coach_game_id,
        instaProAccessToken
      )
    }
    if (data.success) {
      commit("setNewSubscriptionPackages", data.result)
      commit("setSubscriptionPackages", data.result)
    }
  },
  async updateSubscriptionPackages ({ rootGetters, state }, coachGameId) {
    const instaProAccessToken =
      rootGetters["User/Coaching/getInstaProAccessToken"]
    await setSubscriptionPackages(
      coachGameId,
      { subscription_packages: state.newSubscriptionPackages },
      instaProAccessToken
    )
  },
  async getSubscriptionsForCoachGame ({ commit, rootGetters }) {
    const instaProAccessToken =
      rootGetters["User/Coaching/getInstaProAccessToken"]
    const data = await getSubscriptionsForCoachGame(instaProAccessToken)
    if (data.success) {
      commit("setSubscriptionForGame", data.result)
    } else {
      commit("setSubscriptionForGame", [])
    }
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
}



// WEBPACK FOOTER //
// ./src/store/modules/coaching/CoachSubscription.js